<template>
  <Main>
    <div class="center-horizontal-vertical">
      <v-img src="../assets/imaps_logo.png" width="500" />
    </div>
  </Main>
</template>

<style>
.center-horizontal-vertical {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>

<script>
import Main from "../Main.vue";

export default {
  components: {
    Main,
  },
  mounted() {
    // const userData = JSON.parse(localStorage.getItem("userData"));
    // console.log(userData.USER_ID)
  },
};
</script>
